<template>
  <!-- 对齐 App mine.dart：与 App 端一致不要 AppBar（// appBar: Appbar(...) 注释里也没启用） -->
  <div class="mine-page">

    <div class="mine-warp">
      <!-- 顶部用户信息（头像 + 用户名 + Edit profile） -->
      <div class="mine-user" @click="onEditProfile">
        <div class="mine-user-avatar">
          <img :src="avatarUrl" alt="" />
        </div>
        <div class="mine-user-info">
          <div class="mine-user-name">{{ userName }}</div>
          <div class="mine-user-edit">{{ i18n.edit_profile }}</div>
        </div>
      </div>
    </div>

    <!-- 卡片容器（白底 + 顶部圆角 30） -->
    <card-container>
      <!-- 第一组卡片：Order / Payments / Help -->
      <div class="mine-card">
        <div class="mine-menu-row">
          <div class="mine-menu-cell" @click="onMenuClick('order')">
            <img
              class="mine-menu-icon"
              src="../../assets/imgs/icon_rentals.png"
              alt=""
            />
            <div class="mine-menu-label">{{ i18n.order_title }}</div>
          </div>
          <div class="mine-menu-cell" @click="onMenuClick('payment')">
            <img
              class="mine-menu-icon"
              src="../../assets/imgs/icon_payment.png"
              alt=""
            />
            <div class="mine-menu-label">{{ i18n.payment_title }}</div>
          </div>
          <div class="mine-menu-cell" @click="onMenuClick('help')">
            <img
              class="mine-menu-icon"
              src="../../assets/imgs/icon_nav_help_mine.png"
              alt=""
            />
            <div class="mine-menu-label">{{ i18n.help }}</div>
          </div>
        </div>
      </div>

      <!-- 第二组卡片：Download the App / Host / Settings / About Us -->
      <div class="mine-card mine-card-list">
        <div class="mine-list-row" @click="onMenuClick('download')">
          <img
            class="mine-list-icon mine-list-icon-theme"
            src="../../assets/imgs/drawer/icon_refer.png"
            alt=""
          />
          <span class="mine-list-label">{{ i18n.download_app }}</span>
        </div>
        <div class="mine-list-row" @click="onMenuClick('host')">
          <img
            class="mine-list-icon"
            src="../../assets/imgs/icon_host.png"
            alt=""
          />
          <span class="mine-list-label">{{ i18n.host }}</span>
        </div>
        <div class="mine-list-row" @click="onMenuClick('settings')">
          <img
            class="mine-list-icon"
            src="../../assets/imgs/icon_setting.png"
            alt=""
          />
          <span class="mine-list-label">{{ i18n.settings }}</span>
        </div>
        <div class="mine-list-row" @click="onMenuClick('about')">
          <img
            class="mine-list-icon"
            src="../../assets/imgs/icon_about_us.png"
            alt=""
          />
          <span class="mine-list-label">{{ i18n.setting_about }}</span>
        </div>
      </div>

      <!-- 底部 tab（公共组件） -->
      <bottom-nav active="mine" class="mine-bottom-nav"></bottom-nav>
    </card-container>
  </div>
</template>

<script>
import { mapState } from "vuex"
import CardContainer from "../../components/common/CardContainer.vue"
import BottomNav from "../../components/common/BottomNav.vue"

export default {
  components: {
    CardContainer,
    BottomNav
  },
  computed: {
    ...mapState(["user"]),
    i18n() {
      return this.$t("mine")
    },
    // 与 App 端 getUserName 对齐：firstName + lastName，没有则用 pname
    userName() {
      const u = this.user || {}
      const fullName =
        u.firstName && u.lastName
          ? `${u.firstName} ${u.lastName}`
          : u.firstName || u.lastName
      return (fullName || u.pname || "").trim()
    },
    // 默认头像（H5 端暂无 avatarUrl，用占位图）
    avatarUrl() {
      const u = this.user || {}
      return u.avatarUrl || require("../../assets/imgs/avatar.png")
    }
  },
  methods: {
    onEditProfile() {
      // 对齐 App mine.dart L316：pushNamed("profile") 进入个人资料页
      this.$router.push("/profile")
    },
    onMenuClick(key) {
      const map = {
        order: "/order",
        // 钱包入口：H5 钱包页含余额 + 卡包（添加卡），跳 /wallet（payment_card 页暂无入口）
        payment: "/wallet",
        help: "/help",
        coupon: "/coupons",
        host: "host",
        settings: "settings",
        about: "/about",
        download: "/download"
      }
      const target = map[key]
      if (target === "host") {
        // 对齐 App mine.dart: launch(Global.website)
        // App 端 website = "https://www.powerdot.com.ng"，H5 用 m. 域名需替换为 www.
        // 用 window.location.href 而非 window.open，避免被浏览器/微信拦截
        let domain = process.env.VUE_APP_DOMAIN.replace("//m.", "//www.")
        return (window.location.href = domain)
      }
      if (target === "settings") return this.$router.push("/settings")
      if (target) this.$router.push(target)
    }
  }
}
</script>

<style lang="less" scoped>
.mine-page {
  position: relative;
  width: 100%;
  height: 100vh;
  background: var(--page-bg);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.mine-warp {
  /* 对齐 App mine.dart L42: top: 100.w，用 padding 不要 margin，否则 height: 100vh + margin-top 会出现滚动条 */
  padding: 100px 50px 0;
  background: var(--page-bg);
}

// 顶部用户信息
.mine-user {
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-bottom: 30px;

  &-avatar {
    width: 160px;
    height: 160px;
    border-radius: 50%;
    overflow: hidden;
    background: #d8d6dc;
    flex-shrink: 0;
    margin-right: 30px;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
    }
  }

  &-info {
    flex: 1;
    min-width: 0;
  }

  &-name {
    font-size: 40px;
    font-weight: 700;
    color: #000;
    line-height: 1.2;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-family: "Montserrat-SemiBold", sans-serif;
  }

  &-edit {
    margin-top: 16px;
    font-size: 26px;
    color: #000;
    font-weight: 400;
  }
}

// 卡片（对齐 App：itemColor 背景 + 圆角 10）
.mine-card {
  background: #f8f6fc;
  border-radius: 18px;
  padding: 0 30px;
  margin: 0 30px 30px;
}

// 第一组 3 列卡片：去掉左右内边距，让 3 cell 真正铺开到 3 列（对齐 App mine.dart）
.mine-card:not(.mine-card-list) {
  padding: 0;
}

.mine-card-list {
  padding: 4px 30px;
}

// 第一组 3 列
.mine-menu-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.mine-menu-cell {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 0;
  cursor: pointer;
}

.mine-menu-icon {
  width: 84px;
  height: 84px;
  display: block;
  margin-bottom: 18px;
}

.mine-menu-label {
  font-size: 30px;
  font-weight: 400;
  color: #000;
  font-family: "Montserrat-Regular", sans-serif;
  text-align: center;
}

// 第二组 4 行
.mine-list-row {
  display: flex;
  align-items: center;
  padding: 32px 0;
  cursor: pointer;

  & + & {
    border-top: 1px solid #ece8f4;
  }
}

.mine-list-icon {
  width: 50px;
  height: 50px;
  margin-right: 26px;
  display: block;
}

// Download the App 图标主题色滤镜（将图标渲染为 #FF8800 橙色）
.mine-list-icon-theme {
  filter: brightness(0) saturate(100%) invert(52%) sepia(85%) saturate(1000%) hue-rotate(358deg) brightness(103%) contrast(101%);
}

.mine-list-label {
  font-size: 32px;
  font-weight: 400;
  color: #000;
  flex: 1;
  font-family: "Montserrat-Regular", sans-serif;
}

.mine-bottom-nav {
  margin-top: auto;
  padding-bottom: 30px;
}
</style>
